import { Box, TextField } from "@mui/material"
import type { FC } from "react"
import { Controller, useFormContext } from "react-hook-form"

import { FIELD_LABEL_CLASSES, TEXT_AREA_STYLING_PROPS } from "@/constants/forms"

export const SubmitPricingForm: FC = () => {
  const { control } = useFormContext()
  return (
    <form>
      <Controller
        name='reasonForUpdate'
        control={control}
        render={({ field, fieldState: { error } }) => (
          <Box className='relative'>
            <label htmlFor='reasonForUpdate' className={FIELD_LABEL_CLASSES}>
              Reason for Update<span className='text-red-600'>*</span>
            </label>
            <TextField
              {...field}
              {...TEXT_AREA_STYLING_PROPS}
              placeholder='Enter description'
              minRows={4}
              error={!!error}
              helperText={error?.message}
            />
          </Box>
        )}
      />
    </form>
  )
}
